import { colors } from '@ui/colors'
import Status from '@ui/elements/Status'
import { StatusProps } from '@ui/elements/Status/types'
import Typography from '@ui/typography'
import React from 'react'
import { View } from 'react-native'
import cn from '@ui/utils/cn'

interface Props {
  title?: string
  desc?: string
  children?: React.ReactNode
  row?: boolean // children displayed as flex-row
  group?: boolean // used as a wrapper for multiple InputsSections
  inner?: boolean // used inside InputsSections group
  divider?: boolean // used to add a bottom border under header section (for group)
  statusProps?: StatusProps
  inactive?: boolean // used to style text as disabled
  className?: string
}

export default function InputsSection({
  title,
  desc,
  children,
  row,
  group,
  inner,
  divider,
  statusProps,
  className,
  inactive,
}: Props) {
  return (
    <View
      className={cn(
        'flex w-full flex-col rounded-xl border-black/10 py-8 pt-6',
        group && 'gap-0 overflow-hidden pb-0',
        inner ? 'gap-8 rounded-none border-t' : 'gap-8 border', // inner gap-6 ?
        !(title && desc) && 'pt-8',
        divider && 'pt-8',
        className
      )}
    >
      {(title || desc) && (
        <View
          className={cn(
            'flex flex-row items-start justify-between px-8',
            group && 'pb-2',
            divider && 'border-b border-black/10 pb-8'
          )}
        >
          <View className="flex flex-1 flex-col gap-1">
            {title && (
              <Typography
                variant={inner ? 'SMB' : 'MDB'}
                color={inactive ? colors.black25 : colors.text}
              >
                {title}
              </Typography>
            )}
            {desc && (
              <Typography
                variant="SM"
                color={inactive ? colors.black25 : colors.desc}
              >
                {desc}
              </Typography>
            )}
          </View>
          {statusProps && <Status {...statusProps} />}
        </View>
      )}
      {children && (
        <View
          className={cn(
            'flex w-full flex-col gap-6 px-8',
            row && 'flex-row gap-8',
            group && 'gap-0 px-0'
          )}
        >
          {children}
        </View>
      )}
    </View>
  )
}

export const BorderSection = ({ children }: { children: React.ReactNode }) => {
  const childrenArray = React.Children.toArray(children)
  if (childrenArray.length === 0) return null
  return (
    <View className="flex flex-col gap-8 rounded-xl border border-black/10">
      {childrenArray.map((child, index) => (
        <View
          key={index}
          className={cn(
            'flex flex-col border-t border-black/10 px-8',
            index === 0 && 'border-t-0 border-none'
          )}
        >
          {child}
        </View>
      ))}
    </View>
  )
}
